 document.addEventListener("DOMContentLoaded", function () {

        const cards = document.querySelectorAll(".creative-card");
        const isTouch = window.matchMedia("(hover: none)").matches;

        // ==========================
        // Desktop
        // ==========================
        if (!isTouch) {

            cards.forEach(card => {

                card.addEventListener("click", function () {

                    const url = card.dataset.link;

                    if (url && url !== "") {
                        window.location.href = url;
                    }

                });

            });

            return;
        }

        // ==========================
        // Mobile
        // First tap = Expand
        // Second tap = Navigate
        // ==========================
        cards.forEach(card => {

            card.addEventListener("click", function (e) {

                const isOpen = card.classList.contains("is-hover");

                // First Tap
                if (!isOpen) {

                    e.preventDefault();

                    cards.forEach(c => c.classList.remove("is-hover"));

                    card.classList.add("is-hover");

                    return;
                }

                // Second Tap
                const url = card.dataset.link;

                if (url && url !== "") {
                    window.location.href = url;
                }

            });

        });

    });